import { Map } from 'immutable';
import React from 'react';

import * as game from './game';
import { Optional, RenderedMessage } from './utils';
import * as controls from './controls';

function render_control(control: controls.Controls) {
  return (
      <tr>
        <td>
          <b>{control.description}</b>
        </td>
        <td>
          <kbd>{control.main}</kbd>
        </td>
        <td>
          {
            control.alt.map((alt_key, i) => {
              return (
                <React.Fragment key={i}>
                  {" "} or {" "} <kbd>{alt_key}</kbd>
                </React.Fragment>
              )
            })
          }
        </td>
      </tr>
  );
}


type Props = {
  state: game.GameState,
  err: Optional<Error>,
  msg: Optional<RenderedMessage>,
  extra_div: Optional<React.ReactElement>,
  victory: boolean,
  level_header: string,
  level_victory: React.ReactElement | string,
  level_help: Array<React.ReactElement | string>,
  level_plain?: boolean,
  level_render_classes: Array<string>,
  activePlayer: Optional<number>,
  show_screen: string,
}
function App(props: Props) {
  const state = props.state;
  let main_div: React.ReactElement;
  const makeErrorDiv = (err: React.ReactElement | string) => {
    return (
      <div>
        Bug in game!  Contact developer: {err}
        <br/>
        Pressing any key resumes.
      </div>
    )
  }
  if (props.err !== null) {
    main_div = makeErrorDiv(
      <div>
        {props.err.message}
        <br/>
        {props.err.stack}
      </div>
    )
    // throw props.err;
  } else if (props.show_screen === 'controls') {

    main_div = (
      <div className="controls centerdiv">
        {/*<h4 style={{marginBottom: '0'}}>Controls</h4>*/}
        {/*NOTE: could use e*/}
        <br/>
        <table><tbody>
          <tr>
            <td>
              <b>Movement</b>
            </td>
            <td>
              <kbd>&lt;arrows&gt;</kbd>
            </td>
            <td>
              {" "}
              or <kbd>w</kbd><kbd>a</kbd><kbd>s</kbd><kbd>d</kbd>
              </td>
          </tr>
          {render_control(controls.wait)}
          {render_control(controls.borrow)}
          {render_control(controls.cycle_player)}

          <tr style={{fontSize: '0.4em'}}><td>&nbsp;</td></tr>

          {render_control(controls.undo)}
          {render_control(controls.redo)}
          {render_control(controls.reset)}

          <tr style={{fontSize: '0.4em'}}><td>&nbsp;</td></tr>

          {render_control(controls.level_back)}
          {render_control(controls.level_next)}

          <tr style={{fontSize: '0.4em'}}><td>&nbsp;</td></tr>

          {render_control(controls.levels_menu)}
          {render_control(controls.control_menu)}
          {render_control(controls.about_menu)}
          {render_control(controls.credits_menu)}
        </tbody></table>
        <br/>
        <br/>
          <small>
        Press any key to continue
          </small>

      </div>
    )
  } else if (props.show_screen === 'credits') {
    main_div = (
      <div className="centerdiv" style={{width: 'calc(50vw)', paddingTop: 'calc(10vw)'}}>
        <div>
        Game created by {" "}
        <code><a href="https://www.wuthejeff.com">
          Jeff Wu {" "}
        </a></code>
        </div>

        <br/>
        <div style={{marginBottom: '10px'}}>
        Playtesters and feedback:
        </div>
        <div className="playtesters">
        <code>
          Yang Hong
        </code> {" "}
        <code>
          Yifan Li
        </code> {" "}
        <code>
          Michelle Wu
        </code> {" "}
        <code><a href="https://knexator.itch.io/">
        knexator
        </a></code> {" "}
        <code><a href="https://paulfchristiano.com/">
        Paul Christiano
        </a></code> {" "}
        <code><a href="https://www.skishore.me/">
        Shaunak Kishore
        </a></code> {" "}
        <code><a href="https://karoo13.itch.io/">
        Karoo
        </a></code> {" "}
        </div>

        <br/>
        <br/>
        <br/>
        <small>
        Press any key to continue
        </small>
      </div>
    )
  } else if (props.show_screen === 'about') {
    main_div = (
      <div className="centerdiv" style={{width: 'calc(70vw)', padding: 'calc(5vh) 0'}}>
        {/*
        Code/issues: <a href=""> <code>TODO</code></a>
        <br/>
        <br/>
          */}
        <span  className="warning">
          CONTAINS SPOILERS!  SCROLL DOWN TO READ.
        </span>
        <div style={{height: 'calc(100vh)'}}>
          &nbsp;
        </div>
        <br/>
        <br/>
        This game was inspired by the idea of closed timelike curves.  Time travel games rarely try to maintain a single consistent timeline, but I thought consistency could be a natural way to have puzzle constraints.
        <br/>
        <br/>
        I originally wanted arbitrary wormhole nesting and borrowing of exits/entrances, but found it too complicated to implement, especially in a user friendly way.
        Having two same-color exits is already confusing, so I stopped before that.
        But in general, state can no longer be tracked with simple time gaps, when both endpoints can move!
        If anyone is interested in developing this, let's chat :)
        <br/>
        <br/>
        After struggling with the ambitious version, I abandoned the prototype for 2 years.  I finally came back around to polishing the simpler game around Thanksgiving 2024.
        <br/>
        <br/>
        <br/>
        <small>
        Press any key to continue
        </small>
      </div>
    )
  } else {
    if (props.show_screen !== 'main') {
      return makeErrorDiv(`Unknown screen ${props.show_screen}.  contact dev`)
    }
    let eventsDiv;
    if (props.victory)  {
      eventsDiv = <div style={{whiteSpace: 'pre-wrap'}}>
        {props.level_victory}
      </div>
    } else {
      eventsDiv = (
        <div>
        {props.extra_div}

        <h4 style={{margin: '0px', textAlign: 'left', paddingBottom: '10px'}}>Events</h4>
        <ul style={{margin: '0px', padding: '5px', listStyle: 'none'}}>
          {
          props.state.get('events').sort((ev1: any, ev2: any) => {
            if (ev1.get('time') === undefined || ev1.get('time') === null) {
              return 1;
            }
            if (ev2.get('time') === undefined || ev2.get('time') === null) {
              return -1;
            }
            if (ev1.get('time') < ev2.get('time')) {
              return -1;
            } else if (ev1.get('time') > ev2.get('time')) {
              return 1;
            } else {
              return 0;
            }
          }).map((event, y) => {

          function futureTimeString(delta: number) {
            if (delta > 1) {
              return ` in ${delta} ticks`;
            }
            return ` next tick!`;
          }
          let eventdiv: React.ReactNode;
          switch (game.getEventType(event)) {
            case 'exit': {
              let ex_ev = event as game.ExitEvent;
              let t = ex_ev.get('time');
              let t_str = "";
              if (t !== null) {
                t_str = futureTimeString(t - game.getTime(state) + 1);
              }
              let exit_item = Map({type: 'exit'});
              eventdiv = <div>
                {game.item_display(state, ex_ev.get('item'), {inline: true})}
                {" enters "}
                {game.item_display(state, exit_item, {inline: true})}
                {t_str}
              </div>;
              break;
            }
            case 'exit_wormhole': {
              let ex_ev = (event as game.ExitWormholeEvent)
              let est_remaining = game.estimate_exit_wormhole_remaining_time(state, ex_ev);
              let wormhole_out = Map({
                type: 'wormholeOut', id: ex_ev.get('wormhole_id'),
                out_id: 0, // shouldn't matter
                pushable: state.getIn(['wormholes', ex_ev.get('wormhole_id'), 'outPushable']),
              });
              eventdiv = <div>
              {game.items_display(state, ex_ev.get('items'), {inline: true})}
              {" exits "}
              {game.item_display(state, wormhole_out, {inline: true})}
              {" going "}<kbd>{ex_ev.get('direction')}</kbd>
              {" "}
              {futureTimeString(est_remaining)}</div>;
              break;
            }
            case 'enter_wormhole': {
              let en_ev = (event as game.EnterWormholeEvent)
              let dir = en_ev.get('direction');
              let est_remaining = en_ev.get('time')-game.getTime(state) + 1;
              let wormhole_in = Map({ type: 'wormholeIn', id: en_ev.get('wormhole_id')});
              if (dir === null) {
                eventdiv = <React.Fragment>
                  {game.item_display(state, en_ev.get('item'), {inline: true})}
                  {" enters "}
                  {game.item_display(state, wormhole_in, {inline: true})}
                  {" "}
                  {futureTimeString(est_remaining)}
                </React.Fragment>;
              } else {
                eventdiv = <React.Fragment>
                  {game.item_display(state, en_ev.get('item'), {inline: true})}
                  {" "}
                  goes <kbd>{dir}</kbd> to enter 
                  {" "}
                  {game.item_display(state, wormhole_in, {inline: true})}
                  {" "}
                  {futureTimeString(est_remaining)}
                </React.Fragment>;
              }
              break;
            }
            case 'lay': {
              let l_ev = (event as game.LayEvent)
              let est_remaining = l_ev.get('age') - (state.getIn(['players', l_ev.get('player_id'), 'age']) as number) + 1;
              let p = Map({
                type: 'player', id: l_ev.get('player_id'), facing: null,
              })
              let e = Map({type: 'egg'})
              let missing = state.getIn(['players', l_ev.get('player_id'), 'location']) === null;
              if (missing) {est_remaining--;}
              eventdiv = <React.Fragment>
                {game.item_display(state, p, {inline: true})}
                {" "}
                lays
                {" "}
                {game.item_display(state, e, {inline: true})}
                {" "}
                {futureTimeString(est_remaining)}
                {missing ? " after exiting" : ""}
              </React.Fragment>;
              break;
            }
            case 'hatch': {
              let h_ev = (event as game.HatchEvent)
              let est_remaining = h_ev.get('time')-game.getTime(state) + 1;
              let p = Map({
                type: 'player', id: h_ev.get('player_id'), facing: null,
              })
              let e = Map({type: 'egg'})
              eventdiv = <React.Fragment>
                {game.item_display(state, p, {inline: true})}
                {" "}
                exits
                {" "}
                {game.item_display(state, e, {inline: true})}
                {" "}
                {futureTimeString(est_remaining)}
              </React.Fragment>;
              // eventdiv = <React.Fragment>
              //   {game.item_display(state, e, {inline: true})}
              //   {" "}
              //   will hatch
              //   {" "}
              //   {game.item_display(state, p, {inline: true})}
              //   {" "}
              //   {futureTimeString(est_remaining)}
              // </React.Fragment>;
              break;
            }
            default:
              throw new Error(`Unknown event type: ${game.getEventType(event)}`);
          }
          return <li key={y} className='event'>
            {eventdiv}
          </li>;
          })
        }
        </ul>
        {/*
          <h4 style={{marginBottom: '0px'}}>Birds</h4>
          <ul style={{margin: '0px'}}>
            {(() => {
              let player_ids = Array.from(props.state.get('players').keys());
              player_ids.sort();
              return player_ids.map((player_id, y) => {
                // let playerState: game.PlayerState = props.state.getIn(['players', player_id]) as game.PlayerState;
                // let t = game.getPlayerTime(playerState);
                return <div key={y} className='bird'>
                  <span className='cell' style={{
                    backgroundImage: `url(${process.env.PUBLIC_URL + '/img/bird-right.png'})`,
                  }}></span>
                t={t}
                </div>;
              })
              }
            )()}
          </ul>
          */}

          {props.level_help.length ?
            <React.Fragment>
              <h4  style={{margin: '0px', textAlign: 'left', paddingBottom: '10px'}}>Tips</h4>
              <ul style={{margin: '0px', padding: '5px', listStyle: 'none'}}>
                {props.level_help.map((help_div, i) => 
                  <li key={"help" + i} className='event'>
                    {help_div}
                  </li>
                )}
              </ul>
            </React.Fragment>
            : null
          }
          {props.msg ? 
            <React.Fragment>
              <h4 className="warning" style={{margin: '0px', textAlign: 'left', paddingBottom: '10px', display: 'none'}}>
              Error
              </h4>
              <ul style={{margin: '0px', padding: '5px', listStyle: 'none'}}>
                  <li key={"warn"} className='event warning'>
                    <div className="warning">{props.msg}</div>
                  </li>
              </ul>
            </React.Fragment>
            : null
          }
      </div>
      )
    }
    main_div = (
      <React.Fragment>
        <h3 className="levelname" style={{marginTop: '0px'}}>
          {props.level_header}
        </h3>
        <div className={props.level_render_classes.join(" ")} style={{
          // display: 'flex', flexDirection: 'row', 
          justifyContent: 'center', textAlign: 'center',
          // width: 'calc(80vw)'
        }}>
          <div style={{
            padding: '0px 20px', 
            // flexGrow: 1, flexBasis: 0
            display: 'inline-block', verticalAlign: 'top',
            marginBottom: '1em'
          }}>
          {
            state.get('grid').map((row, y) => {
              return <div key={y} className='gridrow'>
                {row.map((cell, x) => {
                  let classNames: Array<string> = ['cell'];
                  let style: React.CSSProperties = {};
                  let items = cell.get('items');
                  if (items.size === 0) {
                    classNames.push('empty');
                  }
                  let children: Array<React.ReactNode> = [];
                  items.forEach((item, i) => {
                    let inactive = false;
                    if (game.getItemType(item) === 'player') {
                        let id = (item as game.Player).get('id');
                        inactive = id !== props.activePlayer
                    }
                    children.push(
                      <div key={i}>
                        {game.item_display(state, item, {inactive: inactive})}
                      </div>
                    )
                  });
                  return <span key={x} className={classNames.join(' ')} style={style}>
                    {children}
                  </span>;
                })}
              </div>;
            })
          }
              {/*
              t={game.getTime(state)}
                */
              }
          </div>
          <div style={{
            padding: '0 1em', 
            // flexGrow: 1, flexBasis: 0
            display: 'inline-block', verticalAlign: 'top',
            width: 'calc(35vw)'
          }}>
              {eventsDiv}

        </div>
        </div>
      </React.Fragment>
    );
  }
  if (props.level_plain) { 
    return main_div
  }
  return (
      <div className="main">
        {main_div}
      </div>
  );
}

export default App;
